import {StepConfig, StepKey, StepModel} from 'models/registration/StepModel'
import {Memoize} from 'util/memoize'
import {WysiwygType} from '../../../types'
import {RegistrationModel} from '../RegistrationModel'

export type GiftStepConfig = StepConfig & {
	enable: boolean
	consent: WysiwygType
	consent_accept: WysiwygType
	consent_decline: WysiwygType
}

export type GiftStepState = {
	consent?: 'accept' | 'decline'
	lastname?: string
	firstname?: string
	postalcode?: string
	prefecture?: string
	city?: string
	address?: string
	company?: string
	building?: string
	phone?: string
}

export class GiftStepModel extends StepModel<GiftStepConfig> {
	@Memoize()
	get key(): StepKey {
		return 'gift'
	}

	@Memoize()
	get state(): GiftStepState {
		return this.registration.state.gift
	}

	@Memoize()
	get isApplicable(): boolean {
		return !!this.config.enable && this.registration.country === 'JP'
	}

	@Memoize()
	get isReady(): boolean {
		return true
	}

	// ----- State changes ----- //
	setState(newState: GiftStepState): RegistrationModel {
		return this.registration.update({
			gift: newState
		})
	}
}
